import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Breadcrumbs from '../../../shared/breadcrumbs/Breadcrumbs';
import ServicePage from '../../../shared/servicePage/ServicePage';
import sendImageDataCapture from './SendImageDataCapture.json';
import '../../Technical.css';

class SendImageDataCapture extends Component {
    render() {
        var back = this.props.match.path.substring(0, this.props.match.path.lastIndexOf("/"));
        return (
            <div className="technical-main">
                <Breadcrumbs />
                <ServicePage ServiceData={sendImageDataCapture} backLink={back} />
            </div>
        )
    }
}

SendImageDataCapture.propTypes = {
    match:PropTypes.object,
    path: PropTypes.string
  }

export default SendImageDataCapture;